import type { FormParams, FormTabType, ReferencePrompt } from '@/app/types';

export type CreateFormInputValidationError =
  | 'forbiddenReference'
  | 'imageEmpty'
  | 'mediaReferenceEmpty'
  | 'textEmpty'
  | 'uploadingImage'
  | 'uploadingReference';

const hasMediaReference = (referencePrompts: ReferencePrompt[]) =>
  referencePrompts.some((prompt) => prompt.type !== 'element' || prompt.prompt?.modality !== 'text');

export const getReferenceFormInputValidationError = (
  referencePrompts: ReferencePrompt[],
): CreateFormInputValidationError | undefined => {
  if (!hasMediaReference(referencePrompts)) {
    return 'mediaReferenceEmpty';
  }

  if (referencePrompts.some((prompt) => prompt.status === 'forbidden')) {
    return 'forbiddenReference';
  }

  if (referencePrompts.some((prompt) => prompt.status === 'uploading')) {
    return 'uploadingReference';
  }
};

export const getCreateFormInputValidationError = (
  formType: Exclude<FormTabType, 'scene'>,
  formParams: FormParams,
): CreateFormInputValidationError | undefined => {
  if (formType === 'character2video' || formType === 'reference2image') {
    return getReferenceFormInputValidationError(formParams.referencePrompts || []);
  }

  if (formType === 'img2video') {
    if (formParams.imagePrompts.some((prompt) => prompt?.status === 'uploading')) {
      return 'uploadingImage';
    }

    if (!formParams.imagePrompts.some((prompt) => !!prompt?.prompt?.sourceImage)) {
      return 'imageEmpty';
    }

    return undefined;
  }

  if (!formParams.isProMode && !formParams.textPrompt) {
    return 'textEmpty';
  }
};

export const CREATE_FORM_INPUT_ERROR_KEY_MAP: Record<CreateFormInputValidationError, string> = {
  forbiddenReference: 'create.char2VideoForm.error.forbiddenReference',
  imageEmpty: 'create.createForm.error.imageEmpty',
  mediaReferenceEmpty: 'create.createForm.error.mediaReferenceEmpty',
  textEmpty: 'create.createForm.error.textEmpty',
  uploadingImage: 'create.createForm.error.uploadingImage',
  uploadingReference: 'create.char2VideoForm.error.uploadingReference',
};
